import script from "./TableHeaderCellWithSorting.vue?vue&type=script&setup=true&lang=js"
export * from "./TableHeaderCellWithSorting.vue?vue&type=script&setup=true&lang=js"

import "./TableHeaderCellWithSorting.vue?vue&type=style&index=0&id=0689f5a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0689f5a2"]])

export default __exports__